import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        linkFeature: {
          cmsComponents: ['JavascriptLinkComponent', 'CMSLinkComponent']
,          module: () => import('./clickable-link.module').then((m) => m.DpClickableLinkModule),
        },
      },
    }),
  ],
})
export class DpClickableLinkFeatureModule {}

